
export const TCM_STATUS = {
    NEW: 'New',
    DRAFT: 'Draft',
    REVIEW: 'Review',
    FINAL: 'Final'
};

export const TCM_ROLE_IDS = {
    ESS: 106, // changing for testing purposes ESS:106
    BA: 65, // changing for testing purposes BA:65
};

export const getWorkflowStatusCodeForUser = (user) => {
    const roleId = user?.role?.RoleId;

    if (roleId === TCM_ROLE_IDS.BA) {
        return TCM_STATUS.DRAFT;
    }

    if (roleId === TCM_ROLE_IDS.ESS) {
        // Backend may accept "All", but this should mean:
        // New, Review, Final for ESS workflow task visibility.
        return 'All';
    }

    return null;
};

export const canEditWorkflowTask = (user, estimate) => {
    const roleId = user?.role?.RoleId;
    const statusName = estimate?.TCMCostEstimateStatus?.Name;

    if (roleId === TCM_ROLE_IDS.BA) {
        return statusName === TCM_STATUS.DRAFT;
    }

    if (roleId === TCM_ROLE_IDS.ESS) {
        return statusName === TCM_STATUS.NEW || statusName === TCM_STATUS.REVIEW;
    }

    return false;
};

export const canSubmitForDraft = (estimate) => {
    return estimate?.TCMCostEstimateStatus?.Name === TCM_STATUS.NEW;
};

export const canSubmitForReview = (estimate) => {
    return estimate?.TCMCostEstimateStatus?.Name === TCM_STATUS.DRAFT;
};

export const canSubmitForFinal = (estimate) => {
    return estimate?.TCMCostEstimateStatus?.Name === TCM_STATUS.REVIEW;
};

export const canRestartToDraft = (estimate) => {
    return estimate?.TCMCostEstimateStatus?.Name === TCM_STATUS.REVIEW;
};